import React, { useEffect, useState } from "react";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import RemoveIcon from "@mui/icons-material/Remove";

const ChatWidget = ({ iframeDomain, setWidgetOpen, widgetOpen }) => {
  const [fullScreen, setFullScreen] = useState(false);
  const [widgetStyle, setWidgetStyle] = useState({});

  const iconStyles = {
    width: "24px",
    height: "24px",
    cursor: "pointer",
    color: "#1e293b",
    transition: "color 0.2s ease",
  };

  useEffect(() => {
    const updateStyle = () => {
      if (fullScreen) {
        setWidgetStyle({
          position: "fixed",
          bottom: 0,
          right: 0,
          zIndex: 999999,
          overflow: "hidden",
          borderLeft: "2px solid black",
          borderRight: "2px solid black",
          borderBottom: "2px solid black",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width: "100vw",
          height: "calc(100vh - 4rem)",
          display: "block",
        });
      } else {
        const width = window.innerWidth >= 800 ? "600px" : "100%";
        setWidgetStyle({
          position: "fixed",
          bottom: 0,
          right: 0,
          zIndex: 999999,
          overflow: "hidden",
          borderLeft: "2px solid black",
          borderRight: "2px solid black",
          borderBottom: "2px solid black",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          width,
          height: "75vh",
          display: "block",
        });
      }
    };

    window.addEventListener("resize", updateStyle);
    updateStyle();

    return () => {
      window.removeEventListener("resize", updateStyle);
    };
  }, [fullScreen]);

  if (!widgetOpen) return null;

  return (
    <div style={widgetStyle}>
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: "white",
            padding: "1rem",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
          }}
        >
          <div onClick={() => setFullScreen(!fullScreen)}>
            {fullScreen ? (
              <FullscreenExitIcon style={iconStyles} />
            ) : (
              <FullscreenIcon style={iconStyles} />
            )}
          </div>
          <RemoveIcon
            onClick={() => setWidgetOpen(false)}
            style={{
              width: "24px",
              height: "24px",
              cursor: "pointer",
              color: "#1e293b",
              transition: "color 0.2s ease",
            }}
          />
        </div>
        <iframe
          src={iframeDomain}
          style={{
            border: "none",
            width: "100%",
            flexGrow: 1,
          }}
          sandbox="allow-scripts allow-same-origin allow-forms"
          allow={`camera ${iframeDomain.replace(
            "/auth/signin/",
            ""
          )}; microphone ${iframeDomain.replace("/auth/signin/", "")}`}
        />
      </div>
    </div>
  );
};

export default ChatWidget;
